import { render, staticRenderFns } from "./MainModeForm.vue?vue&type=template&id=16b5b9f0"
import script from "./MainModeForm.vue?vue&type=script&lang=js"
export * from "./MainModeForm.vue?vue&type=script&lang=js"
import style0 from "./MainModeForm.vue?vue&type=style&index=0&id=16b5b9f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports